import React from "react";

export const DashboardModule = ({ imgRef, title, onClick, isSelected }) => {
  return (
    <button
    className={`relative w-48 h-48 border rounded-lg items-center justify-center ${isSelected ? "bg-sss-blue-sel" : 'bg-sss-blue'}`}
      onClick={onClick}
    >
      <img
        className="absolute w-5 h-5 top-2 right-2"
        src="assets/dashboard/module-icon-toggle.png"
        alt="Toggle Icon"
      />
      <div className="flex flex-col items-center text-center mt-4">
        <img src={imgRef} alt={title} className="w-20 h-20 object-contain" />
        {title && (
          <h3 className="text-md font-cairo text-white mt-5">{title}</h3>
        )}
      </div>
    </button>
  );
};
